
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import ScrollToTop from "@/components/ScrollToTop";
import { HelmetProvider } from 'react-helmet-async';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import RouteRenderer from '@/routes/RouteRenderer';
import Taskbar from '@/components/Taskbar';
import GlobalSEOProvider from '@/components/seo/GlobalSEOProvider';
import AutoSEOOptimizer from '@/components/seo/AutoSEOOptimizer';
import InternalLinkingEngine from '@/components/seo/InternalLinkingEngine';
import VisibleFAQ from '@/components/seo/VisibleFAQ';

function App() {
  const queryClient = new QueryClient();

  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <GlobalSEOProvider>
            <ScrollToTop />
            <AutoSEOOptimizer />
            <InternalLinkingEngine enabled={true} autoInjectLinks={true} />
            <div className="pb-16 md:pb-0">
              <RouteRenderer />
              <VisibleFAQ />
            </div>
            <Taskbar />
          </GlobalSEOProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </HelmetProvider>
  );
}

export default App;
